import envVariables from '../../consts/envVariables';
import {createClient} from '../dam/damClient';
import uamfClientError from './uamfClientError';

const createHeaders = (token, isUamToken) => ({
    ...(isUamToken ? {authorization: `Bearer ${token}`} : {authorization: `${token}`}),
    'x-api-key': envVariables.UAMF_API_KEY,
    'content-type': 'application/json',
});

const uamfClient = createClient({
    defaultEndpoint: envVariables.UAMF_API_ENDPOINT,
    createHeaders,
    clientError: uamfClientError,
    logPrefix: 'uamfClient',
});

// inject client into error handler to break circular dependency
uamfClientError.setClient(uamfClient);

export default uamfClient;
